module.exports = __webpack_public_path__ + "img/smart.3cc08160.png";